import {  GET_CUTOFF_TIME_REQUEST,
    GET_CUTOFF_TIME_SUCCESS,
    GET_CUTOFF_TIME_ERROR,
    CLEAR_CUTOFF_TIME_REQUEST } from "redux/actions/action-type";

const initialState = {
    cutOffTimeResponse : [],
    isCutOffTimeLoading : false,
    isCutOffTimeSuccess : false,
    isCutOffTimeError : false,
}


const cutOffTimeReducer = (state = initialState, {type, payload}) => {
    switch(type) {
        case GET_CUTOFF_TIME_REQUEST:
            return {
                ...state,
                isCutOffTimeLoading: true,
                isCutOffTimeSuccess: false,
                isCutOffTimeError: false,
            };
        case GET_CUTOFF_TIME_SUCCESS: 
        return {
            ...state,
            cutOffTimeResponse: payload,
            isCutOffTimeLoading: false,
            isCutOffTimeSuccess: true,
            isCutOffTimeError: false,
        };
        case GET_CUTOFF_TIME_ERROR: 
        return {
            ...state,
            cutOffTimeResponse: payload,
            isCutOffTimeLoading: false,
            isCutOffTimeSuccess: false,
            isCutOffTimeError: true,
        };
        case CLEAR_CUTOFF_TIME_REQUEST:
            return initialState;
        default: 
        return state;
    }
}

export default cutOffTimeReducer;